module.exports = __webpack_public_path__ + "static/cf-bold-ce4d2a06ff5d534b7de47bfb2036b75c.woff";